import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import CreatePointPage from "./pages/CreatePointPage";
import PointOfSalePage from "./pages/PointOfSalePage";

export default function App() {
  return (
    <Router>
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/create-point" element={<CreatePointPage />} />
          <Route path="/point/:pointId" element={<PointOfSalePage />} />
        </Routes>
      </main>
    </Router>
  );
}
